import { useMemo } from "react";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";
import {
  ValidatedInfo,
  ValidatingInfo,
} from "../../../../reporting/report-lists/reports/copyto/CompanyMultipleReportsListItemContainer";
import type { SelectedCompany } from "../../../hooks/validationStateSlice";
import type { DashboardValidationType } from "../../hooks/useDashboardValidation";
import CompanyListItem from "./CompanyListItem";

interface Props {
  company: SelectedCompany;
  availableCompanies: ListItemData[];
  validation: DashboardValidationType;
}

const CompanyListItemContainer = ({ company, availableCompanies, validation }: Props) => {
  const isValidating = useMemo(
    () => company.dashboards.flatMap((d) => d.tiles).some((t) => t.validating),
    [company.dashboards]
  );

  const items = useMemo(() => company.dashboards.flatMap((d) => d.tiles), [company.dashboards]);

  if (company.dashboards.length === 0) {
    return null;
  }

  return (
    <CompanyListItem
      key={company.code}
      company={company}
      validation={validation}
      companyBranding={availableCompanies.find((c) => c.value === company.code)}
      Action={<CloseIconButton size="small" onClick={() => validation.removeCompany(company.code)} color="secondary" />}
      Summary={isValidating ? <ValidatingInfo items={items} /> : <ValidatedInfo items={items} />}
    />
  );
};

export default CompanyListItemContainer;
